/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ShelfChangeStatus = "COMPLETED" | "OPEN";

export type GetShelfChangeProposalsQueryVariables = Exact<{
  shelfOrder?: string | null | undefined;
}>;

export type GetShelfChangeProposalsQuery = {
  getShelfChangeProposals: {
    proposals: Array<{
      id: string;
      productName: string | null;
      dueDate: string;
      status: Types.ShelfChangeStatus;
      shelfFrom: string | null;
      shelfTo: string | null;
      sku: string;
    }>;
  };
};

export type GetOpenShelfChangeProposalsCountQueryVariables = Exact<{ [key: string]: never }>;

export type GetOpenShelfChangeProposalsCountQuery = {
  getOpenShelfChangeProposalsCount: { count: number };
};

export type GetShelfChangeProposalByIdQueryVariables = Exact<{
  proposalId: string;
}>;

export type GetShelfChangeProposalByIdQuery = {
  getShelfChangeProposalById: {
    id: string;
    dueDate: string;
    proposalDate: string;
    shelfFrom: string | null;
    shelfTo: string | null;
    sku: string;
    status: Types.ShelfChangeStatus;
    updatedBy: string | null;
    product: {
      sku: string;
      name: string;
      imageUrl: string | null;
      bio: boolean | null;
      numberOfShelfFacings: number | null;
      isShelvedInHandlingUnits: boolean | null;
      countryOfOrigin: { code: string | null };
      inventoryEntry: { shelfNumber: string | null; stock: { shelf: number } | null };
    } | null;
  };
};

export type StartShelfChangeProposalMutationVariables = Exact<{
  proposalId: string;
}>;

export type StartShelfChangeProposalMutation = { startShelfChangeProposal: { success: boolean } };

export type FinishShelfChangeProposalMutationVariables = Exact<{
  proposalId: string;
}>;

export type FinishShelfChangeProposalMutation = { finishShelfChangeProposal: { success: boolean } };

export const GetShelfChangeProposalsDocument = gql`
  query getShelfChangeProposals($shelfOrder: String) {
    getShelfChangeProposals(shelfOrder: $shelfOrder) {
      proposals {
        id
        productName
        dueDate
        status
        shelfFrom
        shelfTo
        sku
      }
    }
  }
`;

/**
 * __useGetShelfChangeProposalsQuery__
 *
 * To run a query within a React component, call `useGetShelfChangeProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShelfChangeProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShelfChangeProposalsQuery({
 *   variables: {
 *      shelfOrder: // value for 'shelfOrder'
 *   },
 * });
 */
export function useGetShelfChangeProposalsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetShelfChangeProposalsQuery,
    GetShelfChangeProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetShelfChangeProposalsQuery, GetShelfChangeProposalsQueryVariables>(
    GetShelfChangeProposalsDocument,
    options,
  );
}
export function useGetShelfChangeProposalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShelfChangeProposalsQuery,
    GetShelfChangeProposalsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetShelfChangeProposalsQuery, GetShelfChangeProposalsQueryVariables>(
    GetShelfChangeProposalsDocument,
    options,
  );
}
// @ts-ignore
export function useGetShelfChangeProposalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetShelfChangeProposalsQuery,
    GetShelfChangeProposalsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetShelfChangeProposalsQuery,
  GetShelfChangeProposalsQueryVariables
>;
export function useGetShelfChangeProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShelfChangeProposalsQuery,
        GetShelfChangeProposalsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetShelfChangeProposalsQuery | undefined,
  GetShelfChangeProposalsQueryVariables
>;
export function useGetShelfChangeProposalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShelfChangeProposalsQuery,
        GetShelfChangeProposalsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetShelfChangeProposalsQuery,
    GetShelfChangeProposalsQueryVariables
  >(GetShelfChangeProposalsDocument, options);
}
export type GetShelfChangeProposalsQueryHookResult = ReturnType<
  typeof useGetShelfChangeProposalsQuery
>;
export type GetShelfChangeProposalsLazyQueryHookResult = ReturnType<
  typeof useGetShelfChangeProposalsLazyQuery
>;
export type GetShelfChangeProposalsSuspenseQueryHookResult = ReturnType<
  typeof useGetShelfChangeProposalsSuspenseQuery
>;
export type GetShelfChangeProposalsQueryResult = Apollo.QueryResult<
  GetShelfChangeProposalsQuery,
  GetShelfChangeProposalsQueryVariables
>;
export const GetOpenShelfChangeProposalsCountDocument = gql`
  query getOpenShelfChangeProposalsCount {
    getOpenShelfChangeProposalsCount {
      count
    }
  }
`;

/**
 * __useGetOpenShelfChangeProposalsCountQuery__
 *
 * To run a query within a React component, call `useGetOpenShelfChangeProposalsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpenShelfChangeProposalsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpenShelfChangeProposalsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpenShelfChangeProposalsCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetOpenShelfChangeProposalsCountQuery,
    GetOpenShelfChangeProposalsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOpenShelfChangeProposalsCountQuery,
    GetOpenShelfChangeProposalsCountQueryVariables
  >(GetOpenShelfChangeProposalsCountDocument, options);
}
export function useGetOpenShelfChangeProposalsCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOpenShelfChangeProposalsCountQuery,
    GetOpenShelfChangeProposalsCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOpenShelfChangeProposalsCountQuery,
    GetOpenShelfChangeProposalsCountQueryVariables
  >(GetOpenShelfChangeProposalsCountDocument, options);
}
// @ts-ignore
export function useGetOpenShelfChangeProposalsCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetOpenShelfChangeProposalsCountQuery,
    GetOpenShelfChangeProposalsCountQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetOpenShelfChangeProposalsCountQuery,
  GetOpenShelfChangeProposalsCountQueryVariables
>;
export function useGetOpenShelfChangeProposalsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOpenShelfChangeProposalsCountQuery,
        GetOpenShelfChangeProposalsCountQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetOpenShelfChangeProposalsCountQuery | undefined,
  GetOpenShelfChangeProposalsCountQueryVariables
>;
export function useGetOpenShelfChangeProposalsCountSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetOpenShelfChangeProposalsCountQuery,
        GetOpenShelfChangeProposalsCountQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetOpenShelfChangeProposalsCountQuery,
    GetOpenShelfChangeProposalsCountQueryVariables
  >(GetOpenShelfChangeProposalsCountDocument, options);
}
export type GetOpenShelfChangeProposalsCountQueryHookResult = ReturnType<
  typeof useGetOpenShelfChangeProposalsCountQuery
>;
export type GetOpenShelfChangeProposalsCountLazyQueryHookResult = ReturnType<
  typeof useGetOpenShelfChangeProposalsCountLazyQuery
>;
export type GetOpenShelfChangeProposalsCountSuspenseQueryHookResult = ReturnType<
  typeof useGetOpenShelfChangeProposalsCountSuspenseQuery
>;
export type GetOpenShelfChangeProposalsCountQueryResult = Apollo.QueryResult<
  GetOpenShelfChangeProposalsCountQuery,
  GetOpenShelfChangeProposalsCountQueryVariables
>;
export const GetShelfChangeProposalByIdDocument = gql`
  query getShelfChangeProposalById($proposalId: String!) {
    getShelfChangeProposalById(proposalId: $proposalId) {
      id
      dueDate
      proposalDate
      shelfFrom
      shelfTo
      sku
      status
      updatedBy
      product {
        sku
        name
        imageUrl
        bio
        numberOfShelfFacings
        isShelvedInHandlingUnits
        countryOfOrigin {
          code
        }
        inventoryEntry {
          shelfNumber
          stock {
            shelf
          }
        }
      }
    }
  }
`;

/**
 * __useGetShelfChangeProposalByIdQuery__
 *
 * To run a query within a React component, call `useGetShelfChangeProposalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShelfChangeProposalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShelfChangeProposalByIdQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGetShelfChangeProposalByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetShelfChangeProposalByIdQuery,
    GetShelfChangeProposalByIdQueryVariables
  > &
    ({ variables: GetShelfChangeProposalByIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetShelfChangeProposalByIdQuery, GetShelfChangeProposalByIdQueryVariables>(
    GetShelfChangeProposalByIdDocument,
    options,
  );
}
export function useGetShelfChangeProposalByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetShelfChangeProposalByIdQuery,
    GetShelfChangeProposalByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetShelfChangeProposalByIdQuery,
    GetShelfChangeProposalByIdQueryVariables
  >(GetShelfChangeProposalByIdDocument, options);
}
// @ts-ignore
export function useGetShelfChangeProposalByIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetShelfChangeProposalByIdQuery,
    GetShelfChangeProposalByIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetShelfChangeProposalByIdQuery,
  GetShelfChangeProposalByIdQueryVariables
>;
export function useGetShelfChangeProposalByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShelfChangeProposalByIdQuery,
        GetShelfChangeProposalByIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetShelfChangeProposalByIdQuery | undefined,
  GetShelfChangeProposalByIdQueryVariables
>;
export function useGetShelfChangeProposalByIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetShelfChangeProposalByIdQuery,
        GetShelfChangeProposalByIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetShelfChangeProposalByIdQuery,
    GetShelfChangeProposalByIdQueryVariables
  >(GetShelfChangeProposalByIdDocument, options);
}
export type GetShelfChangeProposalByIdQueryHookResult = ReturnType<
  typeof useGetShelfChangeProposalByIdQuery
>;
export type GetShelfChangeProposalByIdLazyQueryHookResult = ReturnType<
  typeof useGetShelfChangeProposalByIdLazyQuery
>;
export type GetShelfChangeProposalByIdSuspenseQueryHookResult = ReturnType<
  typeof useGetShelfChangeProposalByIdSuspenseQuery
>;
export type GetShelfChangeProposalByIdQueryResult = Apollo.QueryResult<
  GetShelfChangeProposalByIdQuery,
  GetShelfChangeProposalByIdQueryVariables
>;
export const StartShelfChangeProposalDocument = gql`
  mutation StartShelfChangeProposal($proposalId: String!) {
    startShelfChangeProposal(proposalId: $proposalId) {
      success
    }
  }
`;
export type StartShelfChangeProposalMutationFn = Apollo.MutationFunction<
  StartShelfChangeProposalMutation,
  StartShelfChangeProposalMutationVariables
>;

/**
 * __useStartShelfChangeProposalMutation__
 *
 * To run a mutation, you first call `useStartShelfChangeProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartShelfChangeProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startShelfChangeProposalMutation, { data, loading, error }] = useStartShelfChangeProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useStartShelfChangeProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartShelfChangeProposalMutation,
    StartShelfChangeProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartShelfChangeProposalMutation,
    StartShelfChangeProposalMutationVariables
  >(StartShelfChangeProposalDocument, options);
}
export type StartShelfChangeProposalMutationHookResult = ReturnType<
  typeof useStartShelfChangeProposalMutation
>;
export type StartShelfChangeProposalMutationResult =
  Apollo.MutationResult<StartShelfChangeProposalMutation>;
export type StartShelfChangeProposalMutationOptions = Apollo.BaseMutationOptions<
  StartShelfChangeProposalMutation,
  StartShelfChangeProposalMutationVariables
>;
export const FinishShelfChangeProposalDocument = gql`
  mutation FinishShelfChangeProposal($proposalId: String!) {
    finishShelfChangeProposal(proposalId: $proposalId) {
      success
    }
  }
`;
export type FinishShelfChangeProposalMutationFn = Apollo.MutationFunction<
  FinishShelfChangeProposalMutation,
  FinishShelfChangeProposalMutationVariables
>;

/**
 * __useFinishShelfChangeProposalMutation__
 *
 * To run a mutation, you first call `useFinishShelfChangeProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishShelfChangeProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishShelfChangeProposalMutation, { data, loading, error }] = useFinishShelfChangeProposalMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useFinishShelfChangeProposalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FinishShelfChangeProposalMutation,
    FinishShelfChangeProposalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    FinishShelfChangeProposalMutation,
    FinishShelfChangeProposalMutationVariables
  >(FinishShelfChangeProposalDocument, options);
}
export type FinishShelfChangeProposalMutationHookResult = ReturnType<
  typeof useFinishShelfChangeProposalMutation
>;
export type FinishShelfChangeProposalMutationResult =
  Apollo.MutationResult<FinishShelfChangeProposalMutation>;
export type FinishShelfChangeProposalMutationOptions = Apollo.BaseMutationOptions<
  FinishShelfChangeProposalMutation,
  FinishShelfChangeProposalMutationVariables
>;
